export default "__VITE_ASSET__BFoHNsZv__"